import { forwardRef } from 'react';
import cn from 'classnames';
import { LandingBlock, LandingBlockProps } from '../LandingBlock/LandingBlock';
import { Heading, HeadingLevel } from '../../Heading/Heading';

import styles from './LandingServices.module.scss';
import { ServiceCardProps } from '../../ServiceCard/ServiceCard';
import { Button, ButtonProps } from '../../Button/Button';

interface LandingServicesProps extends LandingBlockProps {
  title?: string;
  headingLevel?: HeadingLevel;
  serviceCards?: ServiceCardProps[];
}

const mock: ServiceCardProps[] = [
  {
    title: 'Service 1',
    text: 'This is my service number one',
    button1: {
      text: 'See more',
      btnStyle: 'tertiary',
    },
    button2: {
      text: 'Book an Apointment',
    },
  },
  {
    title: 'Service 2',
    text: 'This is my service number one',
    button1: {
      text: 'See more',
      btnStyle: 'tertiary',
    },
    button2: {
      text: 'Book an Apointment',
    },
  },
];

export const LandingServices = forwardRef<HTMLElement, LandingServicesProps>(
  (
    {
      headingLevel = 'h2',
      title = 'Put here your title',
      serviceCards = mock,
      ...props
    },
    ref
  ) => {
    const getButtonKey = (button: ButtonProps) =>
      button.to ||
      button.href ||
      button.text ||
      button.icon ||
      'service-action';

    const getCardKey = (serviceCard: ServiceCardProps) =>
      serviceCard.title ||
      serviceCard.text ||
      serviceCard.button1?.text ||
      'service-card';

    const renderActions = (buttons: ButtonProps[]) => {
      if (!buttons.length) return null;

      return (
        <div className={styles.actions}>
          {buttons.map((button) => (
            <Button
              key={getButtonKey(button)}
              {...button}
              glassEffect={button.glassEffect ?? true}
            />
          ))}
        </div>
      );
    };

    const renderServiceCards = () => {
      return serviceCards?.map((sc, index) => {
        const isCallToAction = !sc.text;
        const cardNumber = `${index + 1}`.padStart(2, '0');
        const buttons = [sc.button1, sc.button2].filter(
          Boolean
        ) as ButtonProps[];

        return (
          <article
            key={getCardKey(sc)}
            className={cn(
              styles.card,
              index === 0 && styles.featured,
              isCallToAction && styles['call-to-action']
            )}
          >
            <div className={styles['card-header']}>
              <span className={styles.number}>Article {cardNumber}</span>
              <Heading className={styles['card-title']} headingLevel="h3">
                {sc.title || 'Article'}
              </Heading>
            </div>
            {sc.text ? (
              <p className={styles.text}>{sc.text}</p>
            ) : (
              <p className={styles.text}>
                Browse more educational notes and choose the topic you would
                like to discuss with Dr. Jessica.
              </p>
            )}
            {renderActions(buttons)}
          </article>
        );
      });
    };

    return (
      <LandingBlock classname={styles.block} {...props} ref={ref}>
        <>
          <div className={styles.header}>
            <span className={styles.eyebrow}>Wellness journal</span>
            <Heading className={styles.title} headingLevel={headingLevel}>
              {title}
            </Heading>
            <p className={styles.subtitle}>
              Educational notes about preventive, functional, and regenerative
              care. Each article can be used as a starting point for a private
              consultation.
            </p>
          </div>
          <div className={styles['services-container']}>
            {renderServiceCards()}
          </div>
        </>
      </LandingBlock>
    );
  }
);

LandingServices.displayName = 'LandingServices';
